// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-value {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.option-value-title {
  font-size: 1.25em;
  font-weight: bold;
}
.option-value-container {
  flex: 1 1;
  margin-top: 2em;
  margin-inline: 2em;
  padding: 2em;
  border-radius: 1em;
  background-color: #fff;
}
.option-value-header {
  display: flex;
  gap: 1em;
  align-items: center;
}
.option-value-header h1 {
  margin: 0;
}
.option-value-form {
  display: flex;
  flex-direction: column;
}
.option-value-form-layout {
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
}
.option-value-form-radio-group {
  width: 100%;
  margin: 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.option-value-form-radio {
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-check {
  margin: 1em;
}

.link-content-container {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/views/dropdowns/dropdownOptionValueForm/dropdownOptionValueForm.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECFC,aAAA;EACA,uBDEc;ECDd,uBDCsB;EACtB,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAAD;AAEC;EACC,iBAAA;EACA,iBAAA;AAAF;AAGC;EACC,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBEjBM;AFgBR;AAIC;EACC,aAAA;EACA,QAAA;EACA,mBAAA;AAFF;AAIE;EACC,SAAA;AAFH;AAMC;EACC,aAAA;EACA,sBAAA;AAJF;AAME;ECrCD,aAAA;EACA,6BDqCgB;ECpChB,uBDoC8B;EAC5B,eAAA;AAFH;AAKE;EACC,WAAA;EACA,WAAA;ECtCF,aAAA;EACA,sBAAA;EACA,2BDqCsB;ECpCtB,uBDoCkC;AAAnC;AAGE;EChDD,aAAA;EACA,uBDgDgB;EC/ChB,mBD+CwB;AACzB;;AAIA;EACC,WAAA;AADD;;AAIA;EACC,WAAA;AADD","sourcesContent":["@import '../../../../sass/globals/globals.scss';\n@import '../../../../sass/globals/mixins.scss';\n\n.option-value {\n\t@include flex(center, flex-start);\n\tflex: 1;\n\theight: 100%;\n\tbox-sizing: border-box;\n\toverflow: scroll;\n\n\t&-title {\n\t\tfont-size: 1.25em;\n\t\tfont-weight: bold;\n\t}\n\n\t&-container {\n\t\tflex: 1;\n\t\tmargin-top: 2em;\n\t\tmargin-inline: 2em;\n\t\tpadding: 2em;\n\t\tborder-radius: 1em;\n\t\tbackground-color: $white;\n\t}\n\n\t&-header {\n\t\tdisplay: flex;\n\t\tgap: 1em;\n\t\talign-items: center;\n\n\t\th1 {\n\t\t\tmargin: 0\n\t\t}\n\t}\n\n\t&-form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t&-layout {\n\t\t\t@include flex(space-evenly, flex-start);\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&-radio-group {\n\t\t\twidth: 100%;\n\t\t\tmargin: 1em;\n\t\t\t@include flexColumn(flex-start, flex-start);\n\t\t}\n\n\t\t&-radio {\n\t\t\t@include flex(center, center);\n\t\t}\n\t}\n}\n\n.form-check {\n\tmargin: 1em;\n}\n\n.link-content-container{\n\twidth: 100%;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
